<script>
  import { onMount } from 'svelte';
  import initWorkersMap from './maps.js';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import { fly } from 'svelte/transition';
  import session from '../lib/session';
  import settings from '../config';

  // internal variables ---------------------------------------------------- //

  let explanation;
  let is_opened = true;
  let google_map_script_url = `https://maps.googleapis.com/maps/api/js?key=${settings.google_maps_api_key}&callback=init_workers_map`;

  // initialization -------------------------------------------------------- //

  const init_workers_map = async () => {
    const waiting = setInterval(async () => {
      if (window && 'google' in window && $session.api_config) {
        const merchant = $session.merchant;

        if (merchant) {
          clearInterval(waiting);
          const container = document.querySelector('#auth-app');
          let height = window.screen.availHeight - 54; //remove topAppBar
          container.setAttribute('style', 'height: ' + height + 'px;');
          await initWorkersMap(google, merchant);
        }
      }
    }, 100);
  };

  const toggle_info = () => {
    is_opened = !is_opened;
  };

  $: explanation = t9n(TS.WORKER_MAP_SECURITY);

  onMount(async () => {
    window.init_workers_map = await init_workers_map();
  });
</script>

<svelte:head>
  <script src={google_map_script_url} defer>

  </script>
  <script src="/vendor/marker-cluster/markerclusterer.js" defer>

  </script>
</svelte:head>

<div class="workers-map">
  {#if is_opened}
    <div transition:fly={{ duration: 500 }} class="explanation">
      <p>{explanation}</p>
      <i
        class="material-icons delete-icon"
        on:click={() => toggle_info()}
        aria-hidden="true">
        close
      </i>

    </div>
  {/if}

  <div id="info_map" style="overflow: hidden" />
</div>

<style>
  .workers-map .explanation p {
    display: inline !important;
  }

  .workers-map .explanation .material-icons {
    position: absolute;
    right: 13px;
    top: 8.5px;
    /*top: 15px;*/
    cursor: pointer;
  }

  .workers-map .explanation {
    position: absolute;
    display: flex;
    z-index: 2;
    /*right: 0;*/
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    top: 70px;
    width: 490px;
    /*width: 80%;*/
    /*padding-right: 40px;*/
    /*height: 33px;*/
    /*margin: 0;*/
    /*padding: 15px;*/
    padding-left: 15px;
    padding-right: 15px;
    /*padding-bottom: 15px;*/
    /*padding-top: 13px;*/
    background-color: var(--mdc-theme-secondary);
    border-radius: 10px;
    color: white;
    font-size: 10pt;
  }

  #info_map {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: lightgray;
    padding-top: 50px;
  }

  /* Mobile Mode
   *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .explanation {
      width: 269px !important;
      margin-left: 71px !important;
    }
  }
</style>
